import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//Получение списка сигналов
export const apiGetFavouritesSignals = async () => {
  const url = `${backendUrl}/api/signals/bookmark/ `;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  try{
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при получении списка избранных сигналов: HTTP error! Status: ${ response.status }`);
    }
    return await response.json();
  } catch{
    throw error;
  }
};